// src/components/Dashboard.js
import React from 'react';
import GPSPanelWithLiveData from './GPSPanelWithLiveData';

const Dashboard = () => {
  return (
    <div className="w-full h-full">
      <GPSPanelWithLiveData />
    </div>
  );
};

export default Dashboard;
